
// import { IncidentCategoryFacade } from './../../../../gateway/src/lib/states/+gateway/gateway.facades';


import { Component, OnInit, AfterContentChecked, ChangeDetectorRef, ViewChild  } from '@angular/core';

import { Observable, Subscription } from 'rxjs';
import {
  LandTitleDto,
      IncidentCategoryDto,
      IncidentDto,
      IncidentSubCategoryDto,
      IncidentQuantumOfImpactDto,
      FacilityAssetDto,
      CleanUpStatusDto,
      UomDto,
      OwnershipTypeDto,
      AppConfigurationDto,
      SecurityClassificationDto,
      RackTrayRefDto,
      FiscalFileLocationDto,
      LandTitleRegisterDto,
      DocumentTypeCodeDto,
      DocumentTypeDto

} from '@cradua/data';

import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

import { IncidentFacade } from '../states/incident.facade';
// import {IncidentCategoryFacade} from './../../../../epims-references/src/lib/states/';
import { loadGateway } from './../../../../gateway/src/lib/states/+gateway/gateway.actions';
import { updateGateway } from './../../../../gateway/src/lib/states/+gateway/gateway.actions';
import { addGateway } from './../../../../gateway/src/lib/states/+gateway/gateway.actions';
import { updateIncident } from './../states/incident.actions';
import { fadeInAnimation } from 'libs/shared/src/lib/_animations/fade-in.animation';
import { BankDto, TitleDto, AddressBookDto, AreaOfImpactDto, PartyDto, TerrainDto,StateDto, CommunityDto, LgaDto } from '@cradua/data';
import { AcquisitionGenericFacade } from '../states/+acquisition-generic/acquisition-generic.facade';
import { PipelineGenericFacade } from '../states/+pipeline-generic/pipeline-generic.facade';
import { ImpactedAssetDto } from '@cradua/data';
import { IncidentListComponent } from '../components/incident/incident-list/incident-list.component';
import { IncidentSearchComponent } from '../components/incident/search/incidentsearch.component';
import { DocumentFacade } from "./../../../../generic-document/src/lib/document-states/document.facade";
import { IncidentComponent } from '../components/incident/incident.component';


@Component({
  selector: 'cradua-incident-container',
  templateUrl: './incident-container.component.html',
  styleUrls: ['./incident-container.component.scss'],
  animations:[fadeInAnimation],
})
export class IncidentContainerComponent implements OnInit  {



  isLoadingImpactedAsset$: Observable<any>;

  isLoadingIncidentCategory$: Observable<any>;
  isLoadingIncidentSubCategory$: Observable<any>;
  isLoadingAppConfig$: Observable<any>;
  isLoadingQuantum$: Observable<any>;
  isLoadingFacilityAsset$: Observable<any>;
  isLoadingCleanUpStatus$: Observable<any>;
  isLoadingUom$: Observable<any>;
  isLoadingParty$: Observable<any>;
  isLoadingTerrain$: Observable<any>;
  isLoadingIncident$: Observable<any>;
  isLoadingAreaOfImpact$: Observable<boolean>;
  isLoadingState$:Observable<boolean>;
  isLoadingLga$:Observable<boolean>;
  isLoadingCommunity$:Observable<boolean>;
  isLoadingAddressBook$: Observable<any>;
  isLoadingTitle$: Observable<any>;
  isLoadingBank$: Observable<any>;
  isLoadingLandTitle$: Observable<any>;
  ownershiptypes$: Observable<OwnershipTypeDto[]>
  incidentassets$: Observable<LandTitleDto[]>;
  incident$: Observable<IncidentDto[]>;
  searchIncident$: Observable<IncidentDto[]>;
  findIncident$: Observable<IncidentDto>;
  incidentcategorys$: Observable<IncidentCategoryDto[]>;
  incidentsubcategorys$: Observable<IncidentSubCategoryDto[]>;
  quantums$: Observable<IncidentQuantumOfImpactDto[]>;
  facilityassets$: Observable<FacilityAssetDto[]>;
  cleanupstatuss$: Observable<CleanUpStatusDto[]>;
  impactedassets$: Observable<ImpactedAssetDto[]>;

  uoms$: Observable<UomDto[]>;
  partys$: Observable<PartyDto[]>;
  terrains$: Observable<TerrainDto[]>;
  areaofimpacts$:Observable<AreaOfImpactDto[]>;
  states$:Observable<StateDto[]>;
  lgas$:Observable<LgaDto[]>;
  titles$:Observable<TitleDto[]>;
  banks$:Observable<BankDto[]>;
  appConfig$:Observable<AppConfigurationDto[]>;
  communities$:Observable<CommunityDto[]>;
  addressBook$: Observable<AddressBookDto[]>;

  isLoadingFileLocation$: Observable<any>;
  isLoadingDocumentType$: Observable<any>;
  isLoadingDocumentTypeCode$: Observable<any>;
  isLoadingSecurityClassification$: Observable<any>;
  isLoadingDocument$: Observable<any>;

  completed$: Observable<boolean>;
  progress$: Observable<number>;
  error$: Observable<string>;
  isInProgress$: Observable<boolean>;
  isReady$: Observable<boolean>;
  hasFailed$: Observable<boolean>;
  hasStarted$: Observable<boolean>;

  fetchDocument$: Observable<LandTitleRegisterDto[]>;
  fileLocation$: Observable<FiscalFileLocationDto[]>;
  documentType$: Observable<DocumentTypeDto[]>;
  documentTypeCode$: Observable<DocumentTypeCodeDto[]>;
  securityClassification$: Observable<SecurityClassificationDto[]>;

  task = "list";
  selectedIncident: IncidentDto;
  landTitle$: Observable<LandTitleDto[]>;

  isLoadingownershiptype$: Observable<boolean>;

  @ViewChild(IncidentListComponent) listChild: IncidentListComponent;
  @ViewChild(IncidentSearchComponent) searchChild: IncidentSearchComponent;
  @ViewChild(IncidentComponent) incidentChild: IncidentComponent;

  constructor(
    // private incidentcayegoryFacade: IncidentCategoryFacade,
    private gatwayFacade: GatewayFacade,
    private incidentfacade: IncidentFacade,
    private pipelineGenericFacade: PipelineGenericFacade,
    private acquisitionGenericFacade: AcquisitionGenericFacade,
    private changeDetector: ChangeDetectorRef,
    private documentFacade: DocumentFacade,


  ) {}


  ngOnInit() {
    this.isLoadingownershiptype$ =  this.gatwayFacade.isLoadingGateway('OwnershipType');
    this.ownershiptypes$ =  this.gatwayFacade.loadGateway('OwnershipType');
    // this.isLoadingAreaOfImpact$ = this.gatwayFacade.isLoadingGateway("AreaOfImpact");
    // this.areaofimpacts$ = this.gatwayFacade.loadGateway("AreaOfImpact");
    this.isLoadingAppConfig$ = this.gatwayFacade.isLoadingGateway("AppConfiguration");
    this.incidentcategorys$ = this.gatwayFacade.loadGateway("IncidentCategory");
    this.isLoadingIncidentCategory$ = this.gatwayFacade.isLoadingGateway("IncidentCategory");

    this.incidentsubcategorys$ = this.gatwayFacade.loadGateway("IncidentSubCategory");
    this.isLoadingIncidentSubCategory$ = this.gatwayFacade.isLoadingGateway("IncidentSubCategory");

    this.quantums$ = this.gatwayFacade.loadGateway("IncidentQuantumOfImpact");
    this.isLoadingQuantum$ = this.gatwayFacade.isLoadingGateway("IncidentQuantumOfImpact");

    this.facilityassets$ = this.gatwayFacade.loadGateway("FacilityAsset");
    this.isLoadingFacilityAsset$ = this.gatwayFacade.isLoadingGateway("FacilityAsset");

    this.cleanupstatuss$ = this.gatwayFacade.loadGateway("CleanUpStatus");
    this.isLoadingCleanUpStatus$ = this.gatwayFacade.isLoadingGateway("CleanUpStatus");

    this.uoms$ = this.gatwayFacade.loadGateway("Uom");
    this.isLoadingUom$ = this.gatwayFacade.isLoadingGateway("Uom");

    this.partys$ = this.gatwayFacade.loadGateway("Party");
    this.isLoadingParty$ = this.gatwayFacade.isLoadingGateway("Party");

    this.terrains$ = this.gatwayFacade.loadGateway("Terrain");
    this.isLoadingTerrain$ = this.gatwayFacade.isLoadingGateway("Terrain");

    this.isLoadingState$ = this.gatwayFacade.isLoadingGateway("State");
    this.states$ = this.gatwayFacade.loadGateway("State");

    this.isLoadingLga$ = this.gatwayFacade.isLoadingGateway("Lga");
    this.lgas$ = this.gatwayFacade.loadGateway("Lga");

    this.isLoadingCommunity$ = this.gatwayFacade.isLoadingGateway("Communities");
    this.communities$ = this.gatwayFacade.loadGateway("Communities");
    this.incident$ = this.incidentfacade.loadIncident;
    this.isLoadingDocument$ = this.documentFacade.isLoadingDocument;
    this.isLoadingAddressBook$ = this.acquisitionGenericFacade.isLoadingAcquisitionGeneric('AddressBook');
    this.addressBook$ = this.acquisitionGenericFacade.loadGatewayWithoutId('AddressBook');
    this.isLoadingAddressBook$ = this.acquisitionGenericFacade.isLoadingAcquisitionGenericWithoutId('AddressBook');

    this.isLoadingTitle$ = this.gatwayFacade.isLoadingGateway("Title");
    this.titles$ = this.gatwayFacade.loadGateway("Title");

    this.isLoadingBank$ = this.gatwayFacade.isLoadingGateway("Bank");
    this.banks$ = this.gatwayFacade.loadGateway("Bank");
    // this.selected$ = this.incidentFacade.incident$;
    // this.findIncident$ = this.incidentFacade.findIncidentRecord$;
  //  this.incident$ = this.gatwayFacade.loadGateway("Incident");
  // this.impactedassets$ = this.gatwayFacade.loadGateway("ImpactedAsset");
  // this.isLoadingImpactedAsset$ = this.gatwayFacade.isLoadingGateway('ImpactedAsset');
  this.fetchDocument$ = this.documentFacade.loadDocument;
  this.landTitle$ = this.pipelineGenericFacade.loadGatewayWithoutId('LandTitle');
  this.isLoadingLandTitle$ = this.pipelineGenericFacade.isLoadingPipelineGenericWithoutId('LandTitle');
  this.states$ = this.gatwayFacade.loadGateway("State");
  this.appConfig$ = this.gatwayFacade.loadGateway("AppConfiguration");
  this.lgas$ = this.gatwayFacade.loadGateway("Lga");
  this.communities$ = this.gatwayFacade.loadGateway("Communities");

  this.securityClassification$ = this.gatwayFacade.loadGateway("SecurityClassification");
  this.documentTypeCode$ = this.gatwayFacade.loadGateway("DocumentTypeCode");
  this.documentType$ = this.gatwayFacade.loadGateway("DocumentType");
  this.fileLocation$ = this.gatwayFacade.loadGateway("FiscalFileLocation");

  this.completed$ = this.documentFacade.completed();
  this.progress$ = this.documentFacade.progress();
  this.error$ = this.documentFacade.error();
  this.isInProgress$ = this.documentFacade.isInProgress();
  this.isReady$ = this.documentFacade.isReady();
  this.hasFailed$ = this.documentFacade.hasFailed();
  this.hasStarted$ = this.documentFacade.started();

  }



  ngAfterViewInit() {
    this.changeDetector.detectChanges();
}

  onHandleIncidentType(value: string) {
    if(value === 'OilSpill') {
      this.filterWithIncidentType(value);
      if(this.incidentChild) {
        this.incidentChild.incidentType = value;
      }
    } else {
     this.filterWithIncidentType(value);
     if(this.incidentChild) {
      this.incidentChild.incidentType = value;
    }
    }

  }

  filterWithIncidentType(value: string) {
   if(this.listChild) {
    this.listChild.incident = this.listChild.incidentClone;
    this.listChild.incident = this.listChild.incident.filter(incident => incident.IncidentTypeStatus === value);
   }
  }

  onSaveIncident(value: any){
    if(value.id != null){
      if(!value.IncidentTypeStatus) {
        value.IncidentTypeStatus = this.searchChild.incidentType;
      }
      this.isLoadingIncident$ = this.incidentfacade.updateIncident(value);
    }else{
      const {id, ...newValue} = value;
      newValue.IncidentTypeStatus = this.searchChild.incidentType;
      this.isLoadingIncident$ = this.incidentfacade.addIncident(newValue);
    }

  }


  onSearch(value) {
    let query = {
      name: value,
    };
   this.isLoadingIncident$ = this.incidentfacade.isLoadingIncident(query);
  }

  onSearchRange(value) {

   this.isLoadingIncident$ = this.incidentfacade.isLoadingIncident(value);
  }

  onTask(task: string) {
    this.task = task;
    this.selectedIncident = null;
    if(this.task === 'create') {
      this.incident$ = this.incidentfacade.clearIncident;
      this.fetchDocument$ = this.documentFacade.loadClearDocument();
      if(this.incidentChild) {
        this.incidentChild.showTab = false;
      this.incidentChild.createIncidentForm();
      }
    }
  //  this.landParcel$ = this.acquisitionGenericFacade.loadGatewayClear('LandParcel');
  }

  onEmitView(value: IncidentDto) {

    if(value != null) {
      this.isLoadingDocument$ = this.documentFacade.isLoadingDocumentById(value.id);
      this.isLoadingIncident$ = this.incidentfacade.isLoadingIncidentById(value.id);

    }

    this.task = 'create';

    if(value?.IncidentTypeStatus) {
      this.searchChild.incidentType = value.IncidentTypeStatus;
    }


  }

  // onAssetSubmit(formData) {

  //   this.gatwayFacade.add("ImpactedAsset", formData);
  // }
  onEmitAssetLocationDelete(value) {
    this.acquisitionGenericFacade.remove('AssetLocation', value);
  }
  onAssetDelete(deletedValue) {
    this.gatwayFacade.remove("ImpactedAsset", deletedValue);
  }

  onSaveAddressBook(value: AddressBookDto) {
    if(value.id === null) {
    value['id'] = undefined;
    }
     const newValue = [];
     newValue.push(value);
     this.acquisitionGenericFacade.add('AddressBook', newValue);
   }

  onEmitList(value: IncidentDto) {
    if(value != null) {
      this.isLoadingIncident$ = this.incidentfacade.isLoadingIncident(value);
    }

    this.task = 'list';

  }

  onSearchAddressBook(query) {
    this.addressBook$ = this.acquisitionGenericFacade.loadGateway('AddressBook', query);
  }

onEmitClearAddressBook(value) {
    // this.acquisitionGenericFacade.loadGatewayClear('AddressBook');
  }


  deletePayment(id) {
    this.gatwayFacade.remove('Lessors', [id]);
  }

  onEmitDelete(id: string) {
    this.incidentfacade.removeIncident(id);
  }
  uploadFile(value: any) {
    const {FilePath, ...doc} = value;
    if(typeof FilePath === 'string') {
      doc['FilePath'] = FilePath;
    }
    doc['type'] = 'landTitleRegister';
    this.documentFacade.uploadSingleDocumentWithFile(doc, FilePath);
  }

  resetUpload(value) {
    this.documentFacade.resetUpload();
  }

  cancelUpload(value) {
    this.documentFacade.cancelUpload();
  }

  onSaveManyDoc(value: LandTitleRegisterDto[]) {
    this.isLoadingDocument$ = this.documentFacade.addAcquisitionDocument(value);
   }



}
